import React, { useState, useEffect } from "react";
import StaffMemberTable from "./Tables/AdminTable";
import AddStaffForm from "./Forms/CreateForm";
import axios from "axios";
import { toast } from "react-toastify";

const StaffManagement = () => {
  const [members, setMembers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingMember, setEditingMember] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const token = sessionStorage.getItem("token");
  console.log("token: ", token);
  // const memberRoleId = "6752956e5401ffe0b4034223";
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userRoleNamesWithId = JSON.parse(sessionStorage.getItem("filteredRoles"));

  const fetchStaffMembers = async (page=1) => {
    try {
      const roleIds = userRoleNamesWithId
        .filter((role) => role.roleName === "Admin")
        .map((role) => role.roleId);

      console.log("Role Ids: ", roleIds)
      console.log("token: ", token);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/hospital-members/get-members-by-roleIds`,
        {
          params: {
            roleIds: roleIds,
            page: page
          },
          headers: {
            Authorization: `Bearer ${token}`,
            "resource-name": userRoleNamesWithId[0].roleName,
          },
        }
      );
      
      const data = response.data.members.filter((member) => member._id !== userDetails.id).map((member) => ({ ...member, roleId: member.roleId._id }));
      setCurrentPage(response.data.currentPage);
      setTotalPages(response.data.totalPages);
      console.log("members: ", data)
      setMembers(data);
    } catch (error) {
      console.error("Error fetching staff members:", error);
    }
  };

  const handleEdit = (member) => {
    setEditingMember(member);
    setShowForm(true);
  };

  const handleAddMember = () => {
    setEditingMember(null);
    setShowForm(true);
  };

  const handleFormSubmit = async (newMember) => {
    try {
      if (editingMember) {
        const roleName = JSON.parse(sessionStorage.getItem("filteredRoles"))
          .find((role) => role.roleId === newMember.get("roleId"))?.roleName || "";
        console.log("Updated data....")
        for (let [key, value] of newMember.entries()) {
          console.log(key, value);
        }
        const res = await axios.put(`${process.env.REACT_APP_BASE_URL}/hospital-members/update/${newMember.get("_id")}`, newMember, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "resource-name": roleName
          }
        })
        if (res.status !== 200) {
          throw new Error(res.data.error);
        }
        setMembers((prevMembers) =>
          prevMembers.map((member) =>
            member._id === editingMember._id ? { ...member, ...res.data.updatedMember } : member
          )
        );
        toast.success(res.data.message, { "position": "top-center" });
        console.log("updatedMember:     ", res.data.updatedMember);

      } else {

        console.log("Submitting Form...", newMember);
        const resourceName = JSON.parse(sessionStorage.getItem("filteredRoles"))
          .find((role) => role.roleId === newMember.get("roleId"))?.roleName || "";

        const res = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/hospital-members/register`,
          newMember,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
              "Content-Type": "multipart/form-data",
              "resource-name": resourceName,
            },
          }
        );

        console.log("Form Submitted Successfully:", res.data);
        setMembers((prevMembers) => [...prevMembers, newMember]);
      }
      setShowForm(false);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.error || "An unexpected error occurred...", { "position": "top-center" })
    }
  };

  const handleDeleteMember = async (id, roleId) => {
    try {
      console.log("roles Details", JSON.parse(sessionStorage.getItem("filteredRoles")))
      const roleName = JSON.parse(sessionStorage.getItem("filteredRoles"))
        .find((role) => role.roleId === roleId)?.roleName || "";
      console.log("roleName: ", roleName); // Outputs: "Doctor"

      const res = await axios.delete(`${process.env.REACT_APP_BASE_URL}/hospital-members/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "resource-name": roleName
        }
      });
      if (res.status !== 200) {
        throw new Error(res.data.error);
      }
      console.log(res.data.message);
      toast.success(res.data.message, { "position": "top-center" });
      setMembers((prevMembers) => prevMembers.filter((newMember) => newMember._id !== id));
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.error || "While deleting, an unexpected error occurred...", { "position": "top-center" })
    }
  };

  useEffect(() => {
    fetchStaffMembers();
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      {!showForm ? (
        <StaffMemberTable
          staffMembers={members}
          onEdit={handleEdit}
          onAdd={handleAddMember}
          onDelete={handleDeleteMember}
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={fetchStaffMembers}
        />
      ) : (
        <AddStaffForm
          member={editingMember}
          onSubmit={handleFormSubmit}
          onCancel={() => setShowForm(false)}
        />
      )}
    </div>
  );
};

export default StaffManagement;
